export const MAX_NOTES_LENGTH = 1000;
export const MAX_NOTES_IMAGES_COUNT = 10;
export const MAX_NOTES_DOCUMENTS_COUNT = 5;

// max file size: 2MB
export const MAX_FILE_SIZE_MB = 2;
export const MAX_FILE_SIZE: number = MAX_FILE_SIZE_MB * 1024 * 1024;

export const MAX_IMAGE_SIZE_MB = 2;
export const MAX_IMAGE_SIZE: number = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export const ALLOWED_DOC_EXT: Array<string> = [
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpointtd',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
